import script from "./ContentLanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentLanguageSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ContentLanguageSwitch.vue?vue&type=style&index=0&id=489d0180&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489d0180"]])

export default __exports__